export const tableTerminSpec = []